import NeshanMap from "utils/react-neshan-map-leaflet/dist/NeshanMap";

export default function PersianMap({ map, activeAddress }) {
  return (
    Array.isArray(map?.addresses) &&
    map?.addresses?.length > 0 && map?.addresses?.map?.((item, i) => (
      <div
        key={i}
        className="tw-h-full tw-w-full tw-absolute tw-top-0 "
        style={{
          zIndex: i === activeAddress ? 10 : i + 1,
        }}
      >
        <NeshanMap
          options={{
            key: "web.zcCB67G3Qzn1qpsdjvPonzicwrKyH8VDc7vzobzn",
            center: item?.location,
            zoom: 13,
          }}
          style={{
            width: "100%",
            borderRadius: "8px",
            height: "100%",
          }}
          onInit={(L, myMap) => {
            let marker = L.marker(item.location)
              .addTo(myMap)
              .bindPopup(item?.title || "");

            myMap.on("click", function (e) {
              marker.setLatLng(e.latlng);
            });

            L.circle(item.location, {
              color: "red",
              fillColor: "#f03",
              fillOpacity: 0.5,
              radius: 500,
            }).addTo(myMap);
          }}
        />
      </div>
    ))
  );
}
